class HeroSlider {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector(".hero-slider__track");
    this.slides = Array.from(el.querySelectorAll(".hero-slide"));
    this.dots = Array.from(el.querySelectorAll(".hero-slider__dot"));
    this.dotsNav = el.querySelector(".hero-slider__dots");

    this.autoplay = el.dataset.autoplay === "true";
    this.speed = parseInt(el.dataset.speed, 10) || 5000;

    this.current = 0;
    this.timer = null;
    this.transitioning = false;

    if (this.slides.length === 0) return;

    this.el.classList.add("hero-slider--no-transition");
    this._activate(0);
    requestAnimationFrame(() => {
      this.el.classList.remove("hero-slider--no-transition");
    });
    this._bindDots();
    this._bindHover();
    this._measureHeader();
    window.addEventListener("resize", this._onResize.bind(this));

    if (this.autoplay && this.slides.length > 1) {
      this._startAutoplay();
    }
  }

  _measureHeader() {
    const announce = document.querySelector(
      ".shopify-section-group-header-group .announcement-bar, #shopify-section-announcement-bar, .announcement-bar"
    );
    const header = document.querySelector(
      ".shopify-section-group-header-group header, #shopify-section-header header, header.header, .section-header"
    );
    const dotsH = this.dotsNav ? this.dotsNav.getBoundingClientRect().height : 0;

    let h = 0;
    if (announce) h += announce.getBoundingClientRect().height;
    if (header) h += header.getBoundingClientRect().height;
    h += dotsH;

    document.documentElement.style.setProperty("--header-height", h + "px");
  }

  _onResize() {
    clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => this._measureHeader(), 100);
  }

  _activate(index) {
    const prev = this.current;
    this.current = index;
    const direction = index > prev ? "forward" : "backward";

    this.el.dataset.direction = direction;

    // set is-prev before removing is-active so CSS can position it
    this.slides[prev].classList.add("is-prev");
    this.slides[prev].classList.remove("is-active");
    this.slides[index].classList.add("is-active");

    // clean up other slides
    this.slides.forEach((s, i) => {
      if (i !== index && i !== prev) {
        s.classList.remove("is-active", "is-prev");
      }
    });

    const durationMs = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue("--slide-duration")
    ) * 1000;

    setTimeout(() => {
      // Disable transition before removing is-prev to prevent visible repositioning
      this.slides[prev].style.transition = "none";
      this.slides[prev].classList.remove("is-prev");
      delete this.el.dataset.direction;
      this.transitioning = false;

      // Re-enable transition after two frames to ensure the style has been applied
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.slides[prev].style.transition = "";
        });
      });
    }, durationMs);

    this.dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
  }

  _goTo(index) {
    if (this.transitioning || index === this.current) return;
    this.transitioning = true;
    this._activate(index);
  }

  _next() {
    const next = (this.current + 1) % this.slides.length;
    this._goTo(next);
  }

  _startAutoplay() {
    this.timer = setInterval(() => this._next(), this.speed);
  }

  _stopAutoplay() {
    clearInterval(this.timer);
  }

  _bindDots() {
    this.dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        this._stopAutoplay();
        this._goTo(i);
        if (this.autoplay) this._startAutoplay();
      });
    });
  }

  _bindHover() {
    this.el.addEventListener("mouseenter", () => {
      if (this.autoplay) this._stopAutoplay();
    });
    this.el.addEventListener("mouseleave", () => {
      if (this.autoplay) this._startAutoplay();
    });
  }
}

document.querySelectorAll(".hero-slider").forEach((el) => new HeroSlider(el));
